module.exports = __webpack_public_path__ + "images/accents/accent-seat-management@2x-1ca37ba62141a2d9d66d4242baf78815.webp";